import React from 'react';
import { makeStyles, Spinner, tokens } from '@fluentui/react-components';
import { ArrowSquareDownRegular, ChevronDownFilled, ErrorCircleRegular } from '@fluentui/react-icons';
import { AlertChip } from '../../../components/Alert/AlertChip';
import { threatResultConfig, ThreatResultType, ThreatType } from '../../../components/threat/threat.config';
import ThreatTable from './ThreatTable';
import { useQuery } from '@tanstack/react-query';
import { useResultStore } from '../../../providers/ResultProvider';
import { ScanResultType } from '../../../types';



type ThreatItemProps = {
    threatKey: ThreatResultType;
    items: ScanResultType[];
    delay?: number;
};

const useStyles = makeStyles({
    container: {
        border: "1px solid transparent",
        borderRadius: "5px",
        padding: "10px 5px",
        "&:hover": {
            cursor: "pointer",
            border: "1px solid #0A78D5",
            transition: "border-color 0.3s ease-in-out",
        },
        display: "flex",
        flexDirection: "column",
        gap: "5px",
    }
});


export default function ThreatItem({ threatKey, items }: ThreatItemProps) {
    const [open, setOpen] = React.useState(false);
    const classes = useStyles();

    const {
        icon: Icon = ErrorCircleRegular,
        title = "",
    } = threatResultConfig[threatKey] || threatResultConfig.default;

    const loading = items?.some((item: ScanResultType) => item.scan_status === "PENDING" || item.scan_status === "IN PROGRESS");;
    const displayItems: ScanResultType[] = loading ? [] : items;

    return (
        <div className={classes.container}>
            {/* ... (rest of the component JSX) ... */}
            <div
                role="button"
                onClick={() => {
                    if (!loading) setOpen(!open);
                }}
                aria-label="Expand"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    cursor: "pointer",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    {!loading && (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <ChevronDownFilled
                                style={{ fontSize: "22px", rotate: open ? "180deg" : "0deg" }}
                            />
                        </div>
                    )}
                    <Icon style={{ fontSize: "16px", color: "#0A78D5" }} />
                    <div style={{
                        whiteSpace: "nowrap",
                        width: 125,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                        <span
                            style={{ fontWeight: 600, fontSize: "14px" }}
                            title={title || threatKey.split("_").join(" ")}
                        >
                            {title || threatKey.split("_").join(" ")}
                        </span>{" "}
                        <span style={{
                            fontSize: "12px",
                            backgroundColor: tokens.colorNeutralBackground5,
                            borderRadius: "5px",
                            fontWeight: 700,
                            padding: "0px 3px",
                        }}>
                            {displayItems?.length}
                        </span>
                    </div>
                </div>
                {loading && <Spinner size="extra-tiny" label="Scanning..." />}
                {!loading && <AlertChip
                    type="success"
                    label="Done"
                    style={{ background: "transparent" }}
                    textStyle={{ fontWeight: 600 }}
                />}
                {/* {isError && <AlertChip type="error" label="Error" />} */}
            </div>
            {!open && Array.isArray(displayItems) && displayItems.length > 0 && (
                <ThreatTable items={displayItems} />
            )}
        </div>
    );
}